module.exports = __webpack_public_path__ + "img/LUB00002.15046392.png";